import { axiosV2 } from "config/@axios";

export const FETCHING = "appPasswordsActions::fetching";
export const SET_ERROR_MESSAGE = "appPasswordsActions::setErrorMessage";
export const FETCH_SUCCESS = "appPasswordsActions::fetchSuccess";
export const RESET = "appPasswordsActions::reset";

export const fetch = () => dispatch => {
  dispatch({ type: FETCHING });

  return axiosV2
    .get("app_passwords", { params: { sort: "-inserttime", count: 100 } })
    .then(response => {
      dispatch({
        type: FETCH_SUCCESS,
        payload: Array.isArray(response.data) ? response.data : []
      });
    })
    .catch(err => {
      dispatch({
        type: SET_ERROR_MESSAGE,
        payload: err.errorMessage
      });
    });
};

export const create = ({ name, protocols, acl }) => () =>
  axiosV2
    .post("app_passwords", {
      name,
      protocols,
      ...(acl?.length > 0 ? { acl } : {})
    })
    .then(response => response.data);

export const remove = id => () => axiosV2.delete(`app_passwords/${id}`);

export const reset = () => ({ type: RESET });
